import {
  COMPONENT_STATE_ARGS,
  MENU_ARGS,
  getDefaultValueFromMetadata,
  pickArgs,
} from '../../../../../utils/spds/metadata';
import { hash } from '@ember/helper';
import Menu from '../../../core/menu/base.gjs';
import MenuItem from './menu-item.gjs';
import Super from '../../../core/base.gjs';

const METADATA = {
  component: 'Spds::Action::Button::Split::Menu',
  description: 'Menu component for split buttons',
  meta: {
    animated: {
      ...COMPONENT_STATE_ARGS.meta.animated,
      defaultValue: true,
    },
    ...pickArgs(COMPONENT_STATE_ARGS, ['open']).meta,
    ...pickArgs(MENU_ARGS, ['anchorElement']).meta,
    toggleOpenState: {
      type: 'function',
      description: 'Function to toggle the open state of the menu',
    },
  },
  name: 'Split Menu',
};

export default class SpdsActionButtonSplitMenu extends Super {
  static metadata = this.setMetadata(METADATA);
  componentName = 'Spds::Action::Button::Split::Menu';

  get animated() {
    return this.args.animated ?? getDefaultValueFromMetadata(this.constructor.metadata, 'animated');
  }

  <template>
    <Menu
      @anchorElement={{@anchorElement}}
      @animated={{this.animated}}
      @open={{@open}}
      data-test-spds-action-button-split-menu
      role="menu"
      {{this.validateArguments}}
      ...attributes
    >
      {{yield
        (hash
          Item=(component
            MenuItem showSelectedStyles=false role="menuitem" toggleOpenState=@toggleOpenState
          )
        )
      }}
    </Menu>
  </template>
}

export const ACTION_BUTTON_SPLIT_MENU_METADATA = SpdsActionButtonSplitMenu.metadata;
